import { Spinner } from "@dashboard/components/Spinner";
import { useAuth } from "@workspace/ui/hooks";
import React from "react";

export const AuthGate = ({ children }: { children: React.ReactNode }) => {
  const { isAuthLoading } = useAuth();

  if (isAuthLoading) {
    return <Spinner />;
  }

  return <>{children}</>;
};
